import Vue from 'vue'
import Router from 'vue-router'
import login from '../m_page/login/login.vue'
import jump from '../m_page/login/jump.vue'
import loginswiper from '../m_page/login/loginswiper.vue'
import register from '../m_page/login/register.vue'
import registerpassword from '../m_page/login/registerpassword.vue'
import registerphone from '../components/registerphone'
import registeremail from '../components/registeremail'
import emailproving from '../m_page/login/emailproving.vue'
import forgetpassword from '../m_page/login/forgetpassword.vue'
import mynews from '../m_page/login/mynews.vue'
import mynewsedit from '../m_page/login/mynewsedit.vue'
import complete from '../m_page/login/complete.vue'
import resetpassword from '../m_page/login/resetpassword.vue'
import resetpasswordphone from '../components/resetpasswordphone'
import resetpasswordemail from '../components/resetpasswordemail'
import resetemailproving from '../m_page/login/resetemailproving.vue'
import resetsuccess from '../m_page/login/resetsuccess.vue'
import registerfalse from '../m_page/login/registerfalse.vue'
import home from '../m_page/home/home.vue'
import activation from '../m_page/home/activation.vue'
import adddeviceType from '../m_page/home/adddeviceType.vue'
import addDevice from '../m_page/home/addDevice.vue'
import bindById from '../m_page/home/bindById.vue'
import finder from '../m_page/finder/finder.vue'
import account from '../m_page/myAccount/account.vue'
import mysearch from '../m_page/myAccount/mysearch.vue'
import releaseSearch from '../m_page/finder/releaseSearch.vue'
import editpet from '../m_page/myAccount/editpet.vue'
import changepassword from '../m_page/myAccount/changepassword.vue'
import addpet from '../m_page/myAccount/addpet.vue'
import addpetType from '../m_page/myAccount/addpetType.vue'
import guide from '../m_page/finder/guide.vue'
import qrPindFet from '../m_page/finder/qrFindPet.vue'
import petDetails from '../m_page/finder/petDetails.vue'
import changefindpetinfo from '../m_page/myAccount/changefindpetinfo.vue'
import privacyStatement from '../m_page/myAccount/privacyStatement.vue'
import petinfo from '../m_page/myAccount/petinfo.vue'
import mapinfo from '../m_page/myAccount/mapinfo.vue'
import store from '../store/store.js'
import loginFailure from '../m_page/login/loginFailure.vue'
import searchmessage from '../m_page/myAccount/searchmessage.vue'
import qrFindError from '../m_page/finder/qrFindError.vue'
import FAQ from "../m_page/myAccount/FAQ.vue"
import mytag from "../m_page/myAccount/mytag.vue"
import scanRecord from "../m_page/myAccount/scanRecord.vue"
import showInformation  from '../m_page/home/showInformation.vue'
//import collor from '../m_page/home/collor/necklace_map.html'
Vue.use(Router)
if (sessionStorage.getItem('token')) {
    store.commit('set_token', sessionStorage.getItem('token'))
}

const router = new Router({
    mode: "history",
    routes: [{
        path: '/home',
        name: 'home',
        component: home,
    },
    {
        path: '/activation',
        name: 'activation',
        component: activation,
    },{
        path:'/adddeviceType',
        name:'adddeviceType',
        component:adddeviceType
    },{ //拍照添加设备
        path: '/addDevice',
        name: 'addDevice',
        component: addDevice,
    },{
        path:'/scanRecord',
        name:'scanRecord',
        component:scanRecord
    },
    { //拍照添加设备
        path: '/bindById',
        name: 'bindById',
        component: bindById,
    },
    //登录，注册
    {
        path: '/login',
        name: 'login',
        component: login
    },
    {
        path: '/loginFailure',
        name: 'loginFailure',
        component: loginFailure
    },
    {
        path: '/loginswiper',
        name: 'loginswiper',
        component: loginswiper
    },
    //注册
    {
        path: '/register',
        name: 'register',
        component: register
    },
    {
        path: '/registerpassword',
        name: 'registerpassword',
        component: registerpassword
    },
    {
        path: '/registerphone',
        name: 'registerphone',
        component: registerphone
    },
    {
        path: '/registeremail',
        name: 'registeremail',
        component: registeremail
    },
    {
        path: '/emailproving',
        name: 'emailproving',
        component: emailproving
    },
    {
        path: '/forgetpassword',
        name: 'forgetpassword',
        component: forgetpassword
    },
    {
        path: '/resetpasswordphone',
        name: 'resetpasswordphone',
        component: resetpasswordphone
    },
    {
        path: '/resetpasswordemail',
        name: 'resetpasswordemail',
        component: resetpasswordemail
    },
    {
        path: '/resetemailproving',
        name: 'resetemailproving',
        component: resetemailproving
    },
    {
        path: '/complete',
        name: 'complete',
        component: complete
    },
    //个人信息
    {
        path: '/mynews',
        name: 'mynews',
        component: mynews
    }, {
        path: '/mynewsedit',
        name: 'mynewsedit',
        component: mynewsedit
    },
    {//FAQ常见问题
        path: '/FAQ',
        name: 'FAQ',
        component: FAQ
    },
    //协寻
    {
        path: '/finder',
        name: 'finder',
        component: finder,
        meta: {
            keepAlive: true
        }
    }, {
        path: '/guide',
        name: 'guide',
        component: guide
    },
    //我的
    {
        path: '/myAccount',
        name: 'account',
        component: account,
        meta: {
            keepAlive: true
        }
    },
    //我的协寻
    {
        path: '/mysearch',
        name: 'mysearch',
        component: mysearch
    },
    //发布协寻
    {
        path: '/releaseSearch',
        name: 'releaseSearch',
        component: releaseSearch
    },
    //重置密码
    {
        path: '/resetpassword',
        name: 'resetpassword',
        component: resetpassword
    },
    //重置成功
    {
        path: '/resetsuccess',
        name: 'resetsuccess',
        component: resetsuccess
    },
    //注册失败
    {
        path: '/registerfalse',
        name: 'registerfalse',
        component: registerfalse
    },
    //添加宠物
    {
        path: '/addpet',
        name: 'addpet',
        component: addpet
    },{//宠物种类
        path:'/addpetType',
        name:'addpetType',
        component:addpetType
    },
    //修改密码
    {
        path: '/changepassword',
        name: 'changepassword',
        component: changepassword
    },
    //编辑宠物信息
    {
        path: '/editpet',
        name: 'editpet',
        component: editpet
    },
    //我的吊牌
    {
        path: '/mytag',
        name: 'mytags',
        component: mytag
    },
    //扫码显示宠物信息--已协寻
    {
        path: '/qrFindPet',
        name: 'qrFindPet',
        component: qrPindFet
    },

    //扫码显示宠物信息--未协寻
//  {
//      path: '/findPetInfo',
//      name: 'findPetInfo',
//      component: findPetInfo
//  },
    //扫码报错页
    {
        path: '/qrFindError',
        name: 'qrFindError',
        component: qrFindError
    },
    //协寻详细信息
    {
        path: '/petDetails',
        name: 'petDetails',
        component: petDetails
    },
    //修改协寻信息
    {
        path: '/changefindpetinfo',
        name: 'changefindpetinfo',
        component: changefindpetinfo
    },
    //隐私声明
    {
        path: '/privacyStatement',
        name: 'privacyStatement',
        component: privacyStatement
    },
    //宠物信息
    {
        path: '/petinfo',
        name: 'petinfo',
        component: petinfo
    },
    //地图
    {
        path: '/mapinfo',
        name: 'mapinfo',
        component: mapinfo
    },
    //我的协寻详情 
    {
        path: '/searchmessage',
        name: 'searchmessage',
        component: searchmessage
    },
    {
        path: '/showInformation',
        name: 'showInformation',
        component: showInformation
    },
    {
        path: '/jump',
        name: 'jump',
        component: jump
    }
    ]
})
router.beforeEach((to, from, next) => {
    if (to.matched.some(r => r.meta.requireAuth)) { //这里的requireAuth为路由中定义的 meta:{requireAuth:true}，意思为：该路由添加该字段，表示进入该路由需要登陆的
        if (store.state.token) {
            next();
        } else {
            next({
                path: '/login',
                query: {
                    redirect: to.fullPath
                }
            })
        }
    } else {
        next();
    }
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js